module.exports = "/images/18K-YG.webp?7970a2d4dade6d1712dc8286c9cad700";